const PageTransition = ({ isLayoutReady }: { isLayoutReady: boolean }) => (
  <div
    style={{
      backgroundColor: '#f3f2f3',
      inset: 0,
      opacity: isLayoutReady ? 0 : 1,
      pointerEvents: 'none',
      position: 'fixed',
      transition: 'opacity 0.2s ease-in-out',
      zIndex: 9999,
    }}
  />
);

export default PageTransition;
